<template>
  <div>
    <section>
      <b-card
        class="my-50"
        no-body
      >
        <div class="admin-table--no-pagination">
          <Table
            :data="allNativeAds"
            class="admin-table__data"
            :columns="nativeAdsColumns"
            :is-loading="isLoading"
            type-of-table="nativeads"
            :enable-pagination="false"
            :enable-sort="false"
          />
        </div>
      </b-card>
    </section>
  </div>
</template>

<script>
import Table from '@/components/Table.vue'
import { computed, onMounted, ref } from '@vue/composition-api'
import store from '@/store'
import translation from '@/mixins/translate'

export default {
  components: {
    Table,
  },
  setup() {
    const nativeAdsColumns = [{
      label: translation.methods.$tk('ClientPortal.Admin.NativeAds.Id'),
      field: 'id',
    },
    {
      label: translation.methods.$tk('ClientPortal.Admin.NativeAds.Name'),
      field: 'name',
    },
    {
      label: translation.methods.$tk('ClientPortal.Admin.NativeAds.DateCreated'),
      field: 'insertDateTime',
    },
    {
      label: translation.methods.$tk('ClientPortal.Admin.NativeAds.LastUpdated'),
      field: 'updateDateTime',
    },
    {
      field: 'actions',
      sortable: false,
    },
    ]
    const allNativeAds = computed(() => store.getters.allNativeAds)
    const isLoading = ref(false)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getNativeAds')
      isLoading.value = false
    })

    return {
      allNativeAds,
      isLoading,
      nativeAdsColumns,
    }
  },
}
</script>
